export default "__VITE_ASSET__B45PtLE8__"